const React = require('react')
const { Col } = require('reactstrap')

const FooterWebsiteColumn = () => {
    return (
        <Col className='footer-section'>
            <div className='footer-logo'>
                <img
                    src='https://res.cloudinary.com/agridential/image/upload/c_scale,w_140/v1584438143/Blockexplorer/vbc_white_gc7yne.svg'
                    alt='VBC Logo'
                />
            </div>
            <div className='footer-description'>
                <div className='website-link'>
                    <img
                        src='https://res.cloudinary.com/agridential/image/upload/c_scale,w_23/v1579059665/samples/food/Internet_Globe_Website_Web_Link_url-512_copy_xhzzvb.png'
                        width='17px'
                        height='17px'
                        alt='Globe'
                    />
                    <a href='https://vietnamblockchain.asia'>
                        vietnamblockchain.asia
                    </a>
                </div>
                <div className='website-link'>
                    <img
                        src='https://res.cloudinary.com/agridential/image/upload/c_scale,w_23/v1579059665/samples/food/Internet_Globe_Website_Web_Link_url-512_copy_xhzzvb.png'
                        width='17px'
                        height='17px'
                        alt='Globe'
                    />
                    <a href='https://vbchain.vn'>vbchain.vn</a>
                </div>
            </div>
            <div className='footer-social'>
                <a
                    href='https://www.facebook.com/VietnamBlockchainCorporation'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <i className='fab fa-facebook-f'></i>
                </a>
                <a
                    href='https://www.linkedin.com/company/vietnamblockchain'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <i className='fab fa-linkedin-in'></i>
                </a>
            </div>
        </Col>
    )
}

module.exports = { FooterWebsiteColumn }
